<template>
  <router-link :to="{path: '/blog/' + slug }">
    <div id="twoColumns">
      <div class="blog-card-large">
        <img :src="backgroundImage">
        <div class="u-margin-bottom-medium">
          <h2 class="heading-secondary right">
            {{ title }}
          </h2>
          <h2 class="heading-tertiary right">
            {{ author }}
          </h2>
        </div>

        <p class="right">
          {{ content }}
        </p>
        <p class="right">
         
            <span v-for="index in tags" :key="index.id">
               <a :href="'/blog/tag/' + index.tag" class="btn-text-small">{{index.tag}}</a></span>
        </p>
      </div>
    </div>
  </router-link>
</template>
<style>
#twoColumns {
        -webkit-column-count: 2; /* Chrome, Safari, Opera */
        -moz-column-count: 2; /* Firefox */
        /* column counts can be changed for num. of columns */
        column-count: 2;
    }
</style>
<script>
export default {
  name: 'BlogCardLarge',
  props: [
    'title',
    'slug',
    'content',
    'datecreated',
    'backgroundImage',
    'tags', 
    'author'
  ],
  computed: {
    day () {
      
      let day = new Date(this.datecreated * 1000)
      day = day.getDate()
      return day
    },
    month () {
      let month = new Date(this.datecreated * 1000)
      month = month.getMonth()
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      const selectedMonthName = months[month]
      return selectedMonthName
    }
  }
}
</script>
<style>
</style>